import { useFullShopifyProducts } from './useFullShopifyProducts';
import { useShopifyProducts } from './useShopifyProducts';

export const useShopifyProductByMerchandiseIds = (merchandiseIds: string[]) => {
  const productsByMerchandiseId = useShopifyProducts({
    merchandiseIds,
  });

  const products = useFullShopifyProducts(
    productsByMerchandiseId.map((p) => p.handle),
  );

  return products;
};
